<template>
</template>

<script>
export default {
  name: "SingleCategory"
}
</script>

<style scoped>

</style>